import React from 'react';
import { Content, PageContainer, Text, TextGroup } from './TermsAndConditionsPage.styles';
import { Header } from '../../../components';
import { Text20Bold } from '../../../components/utils/Text/Text.styles';
import { useOutletContext } from 'react-router-dom';

const TermsAndConditionsPage = () => {
  const outletContext = useOutletContext();
  const [setShowContent] = outletContext || [];

  return (
    <PageContainer>
      <Header title="Terms Of Use" setShowContent={setShowContent} />
      <Content>
        <Text20Bold>1. Acceptance of Terms</Text20Bold>
        <TextGroup>
          <Text>
            By creating a TLINK account, clicking “I Agree,” or otherwise uploading content, you (“Creator,” “you,” or
            “your”) irrevocably accept and agree to be bound by these T&C as of that date (“Effective Date”).
          </Text>
        </TextGroup>
        <TextGroup>
          <Text20Bold>2. Definitions</Text20Bold>
          <Text>
            “Account” – your user credentials on creators.tlink.me. “Content” – any photo, video, audio, text, stream,
            AI generation, metadata, or other material uploaded or transmitted via TLINK. “Gross Revenue” – all amounts
            actually collected from end-users for access to your TLINK profile, paid chats, media sales, tipping, and
            other monetized interactions before any deduction other than (i) VAT/GST or similar sales taxes remitted to
            authorities and (ii) chargebacks/refunds.“Net Revenue” – Gross Revenue minus (i) chargebacks/refunds
            actually processed after the 21-day holding period, (ii) the TLINK platform fee, and (iii) the Telegram
            platform fee. “Referral Creator” – a creator onboarded through a unique referral link or code you generated.
          </Text>
        </TextGroup>
        <Text20Bold>3. Eligibility & Verification</Text20Bold>
        <Text>
          Age. You must be at least 18 years old and legally able to enter into contracts. KYC/AML. You agree to
          complete identity and sanctions screening at onboarding and before each withdrawal request. We may engage
          third-party verification services and store related data as permitted by our Privacy Policy. Accuracy. All
          information you provide must be complete and kept current. Failure may result in suspension. Payout
          Compliance. Payout account details must comply with Section 5 (Payout Account Compliance). Failure to meet
          these requirements may result in suspension, payout delays, or account termination. Account Security. You are
          solely responsible for maintaining the confidentiality of your login credentials and for all activities that
          occur under your Account. TLINK is not liable for any loss or damage arising from unauthorized access to your
          Account.
        </Text>
        <Text20Bold>4. Services & License Grants</Text20Bold>
        <Text>
          TLINK is not Telegram. It is a monetization tool that operates on the Telegram platform, enabling creators to
          deliver and manage paid content via Telegram channels and chats. No Purchases via the App. Creators do not
          purchase digital goods, subscriptions, or services through the App. The App is provided solely as a creator
          monetization and management tool, and all payments flow from the Company to the Creator. End users access
          content exclusively via Telegram and do not enter into any contractual relationship with the Company. Telegram
          Account Ownership For the avoidance of doubt, any Telegram account, channel, bot, or chat created, used, or
          operated by or on behalf of the Company in connection with this Agreement, including any such account
          associated with the Creator’s name, likeness, or digital persona, shall be the sole and exclusive property of
          the Company. The Creator shall have no ownership interest in, and no rights of access to, control over, use
          of, or transfer of any such Telegram account during or after the term of this Agreement. Hosting & Paywall.
          TLINK hosts, paywalls, and delivers your Content to end-users on Telegram channels and chats you authorize.
          Platform License to Creator. We grant you a limited, revocable, non-exclusive license to access the dashboard
          and related APIs solely for legitimate creator monetization. Creator License to TLINK. a. Hosting License. For
          as long as your Account remains active and for so long as we maintain archival backups thereafter, you grant
          TLINK a worldwide, non-exclusive, royalty-free license to host, store, reproduce, distribute, publicly
          display, and perform your Content for end-users according to your paywall settings. b. Promotional License.
          While your Account is active, you grant TLINK a worldwide, royalty-free license to use your name, image,
          likeness, trademarks, and “digital persona” (including AI renderings) in TLINK marketing, without further
          approval. c. Reservation of Rights. You retain all ownership in the underlying Content; TLINK owns all rights
          in the Platform, its compilations, and any anonymized or aggregate data.
        </Text>
        <Text20Bold>5. Creator Earnings & Payment</Text20Bold>
        <Text>
          Creator Earnings & Payment Revenue Share. You are entitled to fifty percent (50%) of Gross Revenue generated
          by your profile (the “Creator Share”). Holding Period. All Gross Revenue is subject to a twenty-one (21) day
          clearance period to manage fraud risk and refunds. Withdrawals. After the applicable clearance period, you may
          request withdrawal of available balances through the payout methods made available by TLINK or its designated
          payment partners from time to time. Available payout methods may include bank transfers, crypto stablecoin
          payments (such as USDC), or other supported methods, subject to availability in your jurisdiction and the
          policies of the applicable payment provider. TLINK and its payment partners may impose minimum withdrawal
          amounts, processing fees, network fees, or other charges, which will be disclosed at the time of withdrawal
          where applicable. Payment Processors and Affiliate Entities. You acknowledge and agree that payouts due under
          these Terms may be made by TLINK directly or through a designated affiliate, payment processor, partner
          company, or third-party service provider, including entities established outside of Cyprus. Any such payment
          shall be deemed payment by TLINK and shall constitute full and final satisfaction of TLINK's payment
          obligations with respect to the applicable amount. Payment Delays. TLINK shall not be responsible for delays,
          interruptions, failures, or inability to complete payouts resulting from banks, payment processors, blockchain
          networks, third-party service providers, technical failures, or circumstances outside of TLINK's reasonable
          control. Compliance Screening. TLINK may delay, reject, suspend, withhold, or reverse payouts where reasonably
          necessary to comply with applicable laws, sanctions programs, anti-money laundering requirements, fraud
          prevention measures, requests from governmental authorities, or the requirements of payment processors and
          financial institutions. Chargebacks and Refunds. If an end-user obtains a chargeback or refund after funds
          have been paid to you, TLINK may deduct the corresponding amount, together with any card-network, payment
          processor, or similar penalties or fees, from your future payouts. You remain ultimately responsible for any
          negative balance. Taxes. You are solely responsible for reporting and paying all income, payroll, VAT, GST,
          withholding, or similar taxes arising from your receipt of Creator Share. TLINK may withhold amounts where
          required by applicable law. Statements. Transaction history made available through the dashboard is provided
          for informational purposes and shall be deemed accurate and conclusive absent manifest error. Payout Account
          Compliance Legal Name Requirement. All payout accounts must be registered in the legal name of the Creator
          receiving the funds or the authorized business entity they represent. The name associated with the payout
          account must exactly match the Creator's verified identity or authorized business documentation. Prohibition
          of Third-Party Payment Accounts. The use of third-party recipient accounts is strictly prohibited. Creators
          may not designate or use payout accounts belonging to any individual or entity other than themselves or their
          authorized business entity. Verification and Review. TLINK requires identity verification during onboarding
          and reserves the right to conduct additional verification checks at any time, including before releasing
          funds, in order to ensure compliance with these Terms. Enforcement. TLINK may suspend or terminate Accounts,
          delay, block, or withhold payouts, require re-verification, or take any other action reasonably necessary if a
          Creator is found to be in breach of this section.
        </Text>
        <Text20Bold>6. Referral Program</Text20Bold>
        <Text>
          Direct Referrals. For each Referral Creator, you earn 4 % of such creator’s Gross Revenue for as long as they
          remain active unless TLINK modifies the plan (see Section 13). Cap & Plan Changes. TLINK may revise percentages, duration, or structure at any time without notice; continued use
          constitutes acceptance. No payments accrue after plan termination.
        </Text>

        <Text20Bold>7. Content Standards & Prohibited Conduct</Text20Bold>
        <Text>
          Illegal or Harmful Content. You must not upload, post, or facilitate any Content that: Depicts or exploits
          minors (real, fictional, or simulated); Involves bestiality, necrophilia, sexual violence, trafficking,
          non-consensual acts, incest, or other unlawful or taboo material; Is deepfake or otherwise manipulated without
          documented consent of depicted persons; Promotes hatred or violence against a protected class; Contains
          private personal data, revenge porn, or defamation; Infringes third-party IP or violates any law. Brand
          Guidelines & Link Titles. Your public links and channel names must comply with TLINK branding guides (e.g.,
          “My Telegram”) and must not mislead users. Repeated violations may result in suspension. Co-authored Content:
          a. You are legally responsible for all Content you upload. You may upload Content that features someone other
          than you ("Co-Authored Content"). b. You warrant that each individual in Co-Authored Content you upload is: i.
          a Creator you have tagged using the tool available on TLINK; or ii. an individual at least 18 years of age
          whose proof of identity and whose written, informed consent you have obtained to share the Content on TLINK.
          c. You and each Co-Author will provide us with necessary documents to confirm you have satisfied the
          requirements of these Terms of Service. d. If you, or anyone appearing in Co-Authored Content, do not provide
          any information we request, we may restrict or delete the Co-Authored Content or your account, and/or withhold
          all or any portion of your Creator Earnings. e. We are not a party to any agreement that you have to create
          Co-Authored Content or any resulting dispute. All claims arising from Co-Authored Content shall be made
          against the Creator(s) who posted or who appear in the Co-Authored Content. You will not make any claims
          against us, and you release us from any claims against us, arising from Co-Authored Content. f. Any
          individual(s) who appear in the Co-Authored Content may, at any time, withdraw their consent to appear in that
          Co-Authored Content. Co-Authored Content may be deleted where a participant withdraws consent. Brand
          Misrepresentation. You must not impersonate TLINK, falsely suggest sponsorship, or create content, links, or
          channels that imply official TLINK status. Community Compliance. You agree to comply with Telegram’s Terms of
          Service at all times.
        </Text>

        <Text20Bold>8. Intellectual-Property Claims & DMCA</Text20Bold>
        <Text>
          TLINK responds to valid takedown notices and may remove Content or disable accounts upon receipt of a lawful
          IP-infringement claim. Repeat infringers will be terminated.
        </Text>

        <Text20Bold>9. Confidentiality</Text20Bold>
        <Text>
          You shall keep all non-public information about TLINK’s technology, pricing, or operations strictly
          confidential, including but not limited to any AI or automation systems powering chats.
        </Text>

        <Text20Bold>10. Term, Termination & Suspension</Text20Bold>
        <Text>
          Term. This Agreement commences on the Effective Date and continues until terminated. Creator Termination. You
          may terminate at will by emailing support@tlink.me, partners@tlink.me, and partnerships@tlink.me. Termination
          is effective when TLINK confirms receipt or within five (5) business days, whichever is earlier. TLINK
          Suspension/Termination. TLINK may, in its sole discretion and without notice, suspend payouts, remove Content,
          or terminate your Account for any reason, including suspected breach, fraud, or reputational risk.
          Post-Termination Rights. Earnings. Cleared balances will be paid on the next scheduled payout cycle. Balances
          subject to ongoing disputes or potential chargebacks will be held until resolved. Content Retention. TLINK may
          retain server copies and archival backups for security, compliance, or evidence purposes unless you
          specifically request permanent deletion in writing. Survival. Sections 5, 6, 7, 8, 9, 11, 12, and 14–18
          survive termination.
        </Text>

        <Text20Bold>11. Modifications to T&C</Text20Bold>
        <Text>
          TLINK may modify these T&C (including revenue terms) at any time without prior notice. Updated terms take
          effect upon posting to creators.tlink.me, and your continued use constitutes acceptance. If you disagree, your
          sole remedy is to terminate your Account under Section 10.2.
        </Text>

        <Text20Bold>12. Warranties & Disclaimers</Text20Bold>
        <Text>
          Creator Warranty. You represent and warrant that: (i) you own or have lawful rights to all Content; (ii) all
          persons depicted are adults who have consented in writing; and (iii) uploading and monetizing the Content
          through TLINK does not violate any law or third-party right. Platform Disclaimer. THE PLATFORM IS PROVIDED “AS
          IS” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. TLINK DOES NOT WARRANT UNINTERRUPTED SERVICE,
          ERROR-FREE OPERATION, OR PROFITABILITY.
        </Text>

        <Text20Bold>13. Limitation of Liability</Text20Bold>
        <Text>
          To the maximum extent permitted by law, TLINK, its affiliates, officers, and employees shall not be liable for
          indirect, incidental, special, consequential, or punitive damages, or for lost profits, even if advised of the
          possibility. TLINK’s aggregate liability under these T&C shall not exceed the total Creator Share actually
          paid to you during the six-month period immediately preceding the claim.
        </Text>

        <Text20Bold>14. Indemnification</Text20Bold>
        <Text>
          You will defend, indemnify, and hold harmless TLINK and its affiliates against any third-party claim arising
          out of (i) your Content, (ii) your breach of these T&C, or (iii) your violation of law.
        </Text>

        <Text20Bold>15. Governing Law & Dispute Resolution</Text20Bold>
        <Text>
          Governing Law. These T&C are governed by the laws of Cyprus, excluding conflict-of-law rules. Arbitration. Any
          dispute shall be finally settled by binding arbitration under the Cyprus Arbitration & Mediation Centre Rules.
          Seat: Nicosia. Language: English. Judgment on the award may be entered in any court of competent jurisdiction.
          Class-Action Waiver. You and TLINK waive any right to litigate or arbitrate claims on a class, collective, or
          representative basis. Injunctive Relief. Nothing herein prevents TLINK from seeking equitable relief for IP or
          confidentiality breaches in any competent court.
        </Text>

        <Text20Bold>16. Relationship of Parties</Text20Bold>
        <Text>
          The parties are independent contractors. Nothing creates a partnership, joint venture, franchise, or
          employment relationship.
        </Text>

        <Text20Bold>17. Assignment</Text20Bold>
        <Text>
          You may not assign or transfer your rights without TLINK’s prior written consent. TLINK may freely assign
          these T&C.
        </Text>
        <Text20Bold>18. Notices</Text20Bold>
        <Text>
          Notices to TLINK must be sent to legal@tlink.me with a paper copy to the registered address of OCAI LTD. TLINK
          may provide notices to you via email or dashboard alert.
        </Text>

        <Text20Bold>19. Entire Agreement; Severability; Waiver</Text20Bold>
        <Text>
          These T&C (including any policies linked or incorporated by reference) constitute the entire agreement and
          supersede all prior understandings relating to the subject matter. If any provision is held invalid, the
          remainder remains enforceable. TLINK’s failure to enforce any provision is not a waiver.
        </Text>
      </Content>
    </PageContainer>
  );
};

export default TermsAndConditionsPage;
